import { z } from 'zod';

export const profileSchema = z.object({
	id: z.string(),
	firstName: z.string(),
	lastName: z.string().optional().nullable(),
	email: z.string().optional().nullable(),
	gender: z.string().optional().nullable(),
	dateOfBirth: z.string().optional().nullable(),
	birthDay: z.number(),
	birthMonth: z.number(),
	birthYear: z.number(),
	supporterNumber: z.number().optional().nullable(),
	mobileNumber: z.string().optional().nullable(),
	nickname: z.string().optional().nullable(),
	ethnicity: z.string().optional().nullable(),
	genderCommunity: z.string().optional().nullable(),
	preferredLanguage: z.string().optional().nullable(),
	homeNumber: z.string().optional().nullable(),
	addressLine1: z.string().optional().nullable(),
	addressLine2: z.string().optional().nullable(),
	addressLine3: z.string().optional().nullable(),
	city: z.string().optional().nullable(),
	zip: z.string().optional().nullable(),
	countryCode: z.string().optional().nullable(),
	favouritePlayerId: z.string().optional().nullable(),
	fanSince: z.number().optional().nullable(),
	twitter: z.string().optional().nullable(),
	facebook: z.string().optional().nullable(),
	snapchat: z.string().optional().nullable(),
	instagram: z.string().optional().nullable(),
	username: z.string().optional().nullable(),
}).nullable();
